import Image from 'next/image';
import { useMemo } from 'react';
import { NETWORKS } from 'src/common/types/network';

import { KeyValueRow, KeyValueTable } from '@/design-system/components/ui';
import useGetChainInfo from '@/hooks/useGetChainInfo';

import { Trigger } from '../../domain';
import { AddressChip } from './components/AddressChip';

interface Props {
  trigger: Trigger;
}

export function MorphoVaultsTriggerFullDetails({ trigger }: Props) {
  const { getChainIconUrl } = useGetChainInfo();

  const vaultAddress = trigger.context?.vault ?? '';
  const chainId = trigger.context?.chain_id;

  const networkInfo = useMemo(() => {
    if (!chainId) return null;
    return NETWORKS.find((network) => network.chainId === chainId);
  }, [chainId]);

  const networkDisplay = useMemo(() => {
    if (!networkInfo) return '-';
    const chainIconUrl = getChainIconUrl(networkInfo.chainId);

    return (
      <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
        {chainIconUrl && <Image src={chainIconUrl} alt={networkInfo.name} width={20} height={20} />}
        <span style={{ textTransform: 'capitalize' }}>{networkInfo.name.replace(/-/g, ' ')}</span>
      </div>
    );
  }, [networkInfo, getChainIconUrl]);

  const vaultDisplay = useMemo(() => {
    if (!vaultAddress || !chainId) return '-';
    return <AddressChip address={vaultAddress} chainId={chainId} />;
  }, [vaultAddress, chainId]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Vault" value={vaultDisplay} />
      <KeyValueRow label="Network" value={networkDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
